// Pricing migration 32 (ADO-3985), R3 21w and 21s: where the toast goes while the side cart is
// open. The boards draw the free-case toasts inside the panel, at its bottom above the totals, so
// the open panel lends `ToastHost` a slot there; with no slot the toast keeps its usual place
// below the site header (Story 7.9).

import { create } from 'zustand';

interface ToastSlotState {
  readonly slot: HTMLElement | null;
  setSlot: (slot: HTMLElement | null) => void;
}

export const useToastSlotStore = create<ToastSlotState>()((set) => ({
  slot: null,
  setSlot(slot) {
    set({ slot });
  },
}));
